import { render } from "./FullName.vue?vue&type=template&id=db7f3070"
import script from "./FullName.vue?vue&type=script&lang=js"
export * from "./FullName.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__